import { ReactNode } from 'react';
import { Separator } from '../Separator';

import styles from './SimpleTable.module.scss';

export const SimpleTable = ({
  content,
  selectedTab,
}: {
  selectedTab: string;
  content: {
    columns: { keyColumn: ReactNode; valueColumn: ReactNode }[];
    footnote?: ReactNode;
  };
}) => {
  return (
    <>
      <div className={styles.tableWrapper}>
        {content.columns
          .map((row, index, array) => [
            () => (
              <div className={styles.tableRow} key={`${row}-${selectedTab}-${index}`}>
                {row.keyColumn}
                {row.valueColumn}
              </div>
            ),
            () => array.length > index + 1 && <Separator className={styles.separator} />,
          ])
          .flat()
          .filter(Boolean)
          .map((C, index) => (
            <C key={index} />
          ))}
      </div>
      {content.footnote}
    </>
  );
};
